import { render, staticRenderFns } from "./CardPropertyList.vue?vue&type=template&id=5daa1a19&"
import script from "./CardPropertyList.vue?vue&type=script&lang=js&"
export * from "./CardPropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QSelect,QBtn,QTooltip}, component.options.components || {})
